export const config = {
  appName: '排播確認系統',
} as const
